"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateNicknameBodyToJSON = exports.UpdateNicknameBodyFromJSONTyped = exports.UpdateNicknameBodyFromJSON = void 0;
function UpdateNicknameBodyFromJSON(json) {
    return UpdateNicknameBodyFromJSONTyped(json, false);
}
exports.UpdateNicknameBodyFromJSON = UpdateNicknameBodyFromJSON;
function UpdateNicknameBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nickname': json['nickname'],
    };
}
exports.UpdateNicknameBodyFromJSONTyped = UpdateNicknameBodyFromJSONTyped;
function UpdateNicknameBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nickname': value.nickname,
    };
}
exports.UpdateNicknameBodyToJSON = UpdateNicknameBodyToJSON;
